import api, { headers, API_V1 } from "./api";

export const signUp = async (body) => {
  return await api.post(`${API_V1}/auth/signup`, body, { headers });
};

export const signIn = async (body) => {
  return await api.post(`${API_V1}/auth/signin`, body);
};

export const forgotpassword = async (body) => {
  return await api.put(`${API_V1}/auth/forgot-password`, body);
};

//
export const googleSignUp = async (body) => {
  return await api.post(`${API_V1}/signup/google`, body);
};
